// const PUBLIC_PATH_NAME = 'ctep-portal';

export default {
  publicPathName: "",
  publicPath: '/'
}